import React from 'react';
import { Clock, LogOut } from 'lucide-react';

interface SessionTimeoutWarningProps {
  remainingSeconds: number;
  onExtend: () => void;
  onSignOut: () => void;
}

const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  remainingSeconds,
  onExtend,
  onSignOut,
}) => {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const display = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-sm mx-4 rounded-xl border border-amber-500/30 bg-gray-900 p-6 shadow-2xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-amber-500/20">
            <Clock className="w-5 h-5 text-amber-400" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-white">Session Expiring</h3>
            <p className="text-sm text-gray-400">Due to inactivity</p>
          </div>
        </div>

        <p className="text-sm text-gray-300 mb-1">
          Your session will expire in
        </p>
        <p className="text-3xl font-mono font-bold text-amber-400 mb-6">{display}</p>

        <div className="flex gap-3">
          <button
            onClick={onExtend}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-fuchsia-600 rounded-lg hover:bg-fuchsia-700 transition-colors"
          >
            Stay Signed In
          </button>
          <button
            onClick={onSignOut}
            className="flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-gray-300 bg-gray-800 border border-gray-700 rounded-lg hover:bg-gray-700 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;
